var HighlightSearchPipe = /** @class */ (function () {
    function HighlightSearchPipe() {
    }
    HighlightSearchPipe.prototype.transform = function (value, args) {
        try {
            if (!args) {
                return value;
            }
            var regex = new RegExp(args, 'gi');
            var match = value.match(regex);
            if (!match) {
                return value;
            }
            return value.replace(regex, "<i class=\"highlight\">" + match[0] + "</i>");
        }
        catch (e) {
            return value;
        }
    };
    return HighlightSearchPipe;
}());
export { HighlightSearchPipe };



// WEBPACK FOOTER //
// ./src/app/shared/HighlightSearchPipe.pipe.ts.pre-build-optimizer.js